export const MONEY_SIGN = {
  kr: '원',
  en: '$',
  jp: '¥',
};
